import React, { useState, useEffect } from "react";
// import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { LangSelector } from "./system/LangSwitch/LangSwitch";
import { PopupForm } from "./popup_form";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";


export const Navigation = (props) => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header" style={{display: "flex"}}>
          <Link className="navbar-brand page-scroll" to="/">
            <span style={{color: "rgba(107, 199, 183, 1)"}}>Hadal</span> Project
          </Link>{" "}
          {/* <div style={{
            marginLeft: "auto"
          }}> */}
              <button className="btn-demo-header" onClick={props.openPopup}>{t("Navigation.demo")}</button>
            {/* </div> */}
            <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={toggleMenu}
            // data-toggle="collapse"
            // data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
        </div>

        <div
          className={`collapse navbar-collapse ${menuOpen ? 'in' : ''}`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/* <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li> */}
            <li>
              <Link to="/" className="page-scroll">
              {t("Navigation.main")}
              </Link>
            </li>
            <li>
              <Link to="/legal/docs" className="page-scroll">
              {t("Navigation.documentation")}
              </Link>
            </li>
            <li>
              <Link to="/about" className="page-scroll">
              {t("Navigation.about")}
              </Link>
            </li>
            {/* <li>
              <a href="#news" className="page-scroll">
                {t("Navigation.news")}
              </a>
            </li> */}
            {/* <li>
              <a href="#services" className="page-scroll">
                {t("Navigation.solution")}
              </a>
            </li> */}
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                {t("Navigation.gallery")}
              </a>
            </li> */}
            {/* <li>
              <a href="#team" className="page-scroll">
                {t("Navigation.team")}
              </a>
            </li> */}
            {/* <li>
              <a href="#conferences" className="page-scroll">
                {t("Navigation.conferences")}
              </a>
            </li> */}
            {/* <li>
              <a href="#teaching" className="page-scroll">
                {t("Navigation.teaching")}
              </a>
            </li> */}
            {/* <li>
              <a href="#contact" className="page-scroll">
                {t("Navigation.contact")}
              </a>
            </li> */}
            {/* <li>
              <button className="btn-demo" onClick={props.openPopup}>{t("Navigation.demo")}</button>
            </li> */}
            <li>
              <LangSelector></LangSelector>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

// Компонент для автоматической прокрутки страницы вверх при переходе на новый маршрут
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // При изменении pathname (пути URL) прокручиваем страницу вверх
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Этот компонент не рендерит никакого UI
}

